/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskResourceType } from './taskResourceType';
import { TaskStatesEnum } from './taskStatesEnum';


export interface RolloutTaskDetails { 
    /**
     * Task ID.
     */
    id?: string;
    /**
     * Task type.
     */
    task_type?: string;
    /**
     * Task sub-type.
     */
    task_sub_type?: string;
    resource_type?: TaskResourceType;
    /**
     * Progress percentage of the task.
     */
    progress_percent?: number;
    /**
     * Start time of the task.
     */
    start_time?: Date;
    /**
     * End time of the task.
     */
    end_time?: Date;
    state?: TaskStatesEnum;
}
export namespace RolloutTaskDetails {
}


